angular.module('cn')

.component('retailers', {
  controller: [
    '$q',
    'networkRelationsRepository',
    'accountsRepository',
    'networksRepository',
    function(
      $q,
      networkRelationsRepository,
      accountsRepository,
      networksRepository
    ) {
      var $ctrl = this;

      var sortRetailers = function(allRetailers, accountRetailers) {
        allRetailers.forEach(function(ret) {
          var x = accountRetailers.findIndex(function(nr) {
            return nr.id === ret.id;
          });
          ret.checked = (x > -1);
          if (x > -1) {
            ret.relationId = accountRetailers[x].relationId;
          }
        });
        allRetailers.$sortFn = function(a,b) {
          if (a.checked < b.checked) {
            return 1;
          }
          if (a.checked > b.checked) {
            return -1;
          }
          return a.name.trim().toLowerCase().localeCompare(b.name.toLowerCase().trim());
        };
        allRetailers.sort(allRetailers.$sortFn);
        return allRetailers;
      };

      var getAllRoots = function(account) {
        return $q.all([
          networksRepository.getAll(),
          accountsRepository.getAll()
        ]).then(function(data) {
          var networks = data[0];
          var accounts = data[1];
          var roots = networks.map(function(net) {
            return net.getRootId();
          });
          return accounts.filter(function(acc) {
            return (roots.indexOf(acc.id) !== -1) && acc.id !== account.id;
          }).map(function(acc) {
            return angular.copy(acc);
          });
        });
      };

      this.$onInit = function() {
        $ctrl.account = $ctrl.resolve.account;
        $ctrl.retailers = [];
        getAllRoots($ctrl.account).then(function(data) {
          $ctrl.retailers = sortRetailers(data, $ctrl.account.getRetailers());
        });
      };

      this.addRetailer = function(receiverAccount) {
        return networkRelationsRepository.addRetailer($ctrl.account, receiverAccount).then(function(ret) {
          $ctrl.account.pushRetailer(ret);
        });
      };

      this.removeRetailer = function(retailer) {
        return networkRelationsRepository.deleteRelation(retailer.relationId).then(function() {
          $ctrl.account.removeRetailer(retailer);
        });
      };

      this.save = function() {
        var prom = [];
        // TO-DO perform this in bulk when backend allows it
        $ctrl.retailers.forEach(function(ret) {
          if (ret.checked && !ret.relationId) {
            prom.push($ctrl.addRetailer(ret));
          }
          if (!ret.checked && ret.relationId) {
            prom.push($ctrl.removeRetailer(ret));
          }
        });
        $q.all(prom).then(function() {
          $ctrl.retailers.sort($ctrl.retailers.$sortFn);
        }).finally(function() {
          $ctrl.close();
        });
      };
    }
  ],
  template: require('./retailers.html'),
  bindings: {
    resolve: '<',
    close: '&'
  }
});



// WEBPACK FOOTER //
// ./src/cn/retailers.js